import React from 'react'

const ToxicologyMain = () => {
  return (
    <div id='website-responsive' className=''>
        <div className='bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Testing-Banner-v1.1.webp")', height:'100%', width:'100%'}}>
            <div className='toxicology-text-padding'>
                <div className='-max-width display-none-1150'>
                    <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                        TOXICOLOGY & DRUG<br/>
                        TESTING SERVICES<br/>
                        IN CHICAGO
                    </text>
                </div>

                <div className='servicesmax-width display-block-1150 lh-1-2'>
                    <text className='fs-ss-32-4 fw-700 text-montserrat fw-600 lh-1 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                        Toxicology testing<br/>
                        services in Chicago
                    </text>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ToxicologyMain